import React, {useState, useEffect} from "react";
import { Form, Row, Col, Input, Button, Collapse ,Card, Table} from 'antd';
import jsonfile from './collection.json'
import {Link, useHistory, useRouteMatch} from "react-router-dom";
import {CisUI} from '../../../../util/CISUI';
import AdvancedSearch from '../../../../util/AdvancedSearch';
import ActionButton from '../../../../util/actionbutton';
import SmartDataTable from 'react-smart-data-table';
import 'react-smart-data-table/dist/react-smart-data-table.css';
import IntlMessages from "util/IntlMessages";
import Config from "../../../../util/config";
import axios from "../../../../util/Api";

const Search = Input.Search;
const Panel = Collapse.Panel;

const CollectionHistory = () => {
    const value = 0;
    const [state,setState] = useState({
        reqURL: Config.apiserver+jsonfile.urls.list,
        reqSumURL: Config.apiserver+jsonfile.urls.summary,
        filtervalue : '',
        subtitle:''
    });

    const [ttl,setTTL] = useState({
        total : 0,
        totalLocal : 0,
        totalDistrict : 0,
        totalRegion : 0,
        totalRemit : 0,
    });

    const history = useHistory();

    const headers = {
        // _id: {
        //     text: '#',
        //     invisible: false,
        //     filterable: false,
        //     transform: (value) => `${++value}`,
        // },
        id: {
            invisible : true
        },
        date: {
            text: <IntlMessages id="Date"/>,
            sortable: true,
            filterable: true,
            transform: (value, idx, row) => (
                CisUI().DateFormat(value)
            )
        },
        total: {
            text: <div style={{textAlign : 'right', width : '100%'}}><IntlMessages id="Total (100%)"/></div>,
            sortable: false,
            filterable: true,
            transform: (value, idx, row) => (
                CisUI().getCurrency(value)
            )
        },
        local_income: {
            text: <div style={{textAlign : 'right', width : '100%'}}><IntlMessages id="Local Income (50%)"/></div>,
            sortable: false,
            filterable: true,
            transform: (value, idx, row) => (
                CisUI().getCurrency(value)
            )
        },
        district_income: {
            text: <div style={{textAlign : 'right', width : '100%'}}><IntlMessages id="District Income (50% of Local)"/></div>,
            sortable: false,
            filterable: true,
            transform: (value, idx, row) => (
                CisUI().getCurrency(value)
            )
        },
        region_income: {
            text: <div style={{textAlign : 'right', width : '100%'}}><IntlMessages id="Region Income (50% of District)"/></div>,
            sortable: false,
            filterable: true,
            transform: (value, idx, row) => (
                CisUI().getCurrency(value)
            )
        },
        remitted: {
            text: <div style={{textAlign : 'right', width : '100%'}}><IntlMessages id="Nation Income (50% of Region)"/></div>,
            sortable: false,
            filterable: true,
            transform: (value, idx, row) => (
                CisUI().getCurrency(value)
            )
        }
    };

    const orderedHeaders = jsonfile.listView.title;

    const getFields = () => {
        const count = expand ? 10 : 6;
        const children = [];
        const inputs = jsonfile.input;

        inputs.map((list, index) => {
            if(list.isFilterable == 1) {
                children.push(
                    <Col lg={6} md={6} sm={12} xs={24} key={index} style={{display: index < count ? 'block' : 'none'}}>
                        <div className="gx-form-row0">
                            <Form.Item
                                name={`${list.name}`}
                                label={`${list.label}`}
                                rules={[
                                    {
                                        required: true,
                                        message: "",
                                    },
                                ]}
                            >
                                <Input placeholder={list.name} />
                            </Form.Item>
                        </div>
                    </Col>,
                );
            }
        });
        return children;
    };

    const [expand, setExpand] = useState(false);
    const [form] = Form.useForm();

    const getTotalSummary = (url) => {
        console.log(url);
        axios.get(url)
            .then(res => {
                console.log(res)
                if(res.data.status === 1) {
                    setTTL(res.data.data);
                }
            })
            .catch(errors => {
                console.log(errors);
            });
    }

    useEffect(() => {
        getTotalSummary(state.reqSumURL);
    }, []);

    const onFinish = values => {
        console.log('Received values of form: ', values);
        const qsup = CisUI().getQueryStrings(values);
        //reqURL = reqURL+"/?"+qsup;
        history.push("?"+qsup);
        const newURL = Config.apiserver+jsonfile.urls.list+"/?"+qsup;
        const newURLSum = Config.apiserver+jsonfile.urls.summary+"/?"+qsup;
        setState({reqURL: newURL, reqSumURL: newURLSum});
        getTotalSummary(newURLSum);
    };

    const handleOnFilter = ({ target: { name, value } }) => {
        //filterValue = value;
        console.log("filteringwith :"+ value);
        setState({filtervalue : "test"});
    }

    let  searchView = "";
    if(jsonfile.has_search) {
        searchView = <Card className="advance-search-card">
            <Collapse
                accordion
                expandIconPosition="right"
                defaultActiveKey={['1']} >
                <Panel header="Advance Search"  key="1">
                    <Form
                        key={5}
                        form={form}
                        {...CisUI().formItemLayout}
                        name="advanced_search"
                        className="ant-advanced-search-form"
                        onFinish={onFinish}
                    >
                        {AdvancedSearch(jsonfile.input,"",1,"date",CisUI().PeriodFiled(form))}
                    </Form>
                </Panel>
            </Collapse>
        </Card>
    }

    const getExtra = (
        <>
            {/*<Search*/}
            {/*    placeholder='Filter...'*/}
            {/*    name='filtervalue'*/}
            {/*    onSearch={handleOnFilter}*/}
            {/*    onChange={handleOnFilter}*/}
            {/*    style={{width: 200}}*/}
            {/*/>*/}
            {CisUI().listAction("../"+jsonfile.urls.add, "", state.reqURL, 'data', 'ministry_income', jsonfile, state.subtitle, "landscape")}
        </>
    );

    return (
        <>
            {searchView}
            <Card title={jsonfile.listtitle} extra={getExtra}>
                <SmartDataTable
                    name='test-fake-table'
                    data={state.reqURL}
                    dataRequestOptions={CisUI().HeaderRequest}
                    dataKey="data"
                    headers={headers}
                    orderedHeaders={orderedHeaders}
                    hideUnordered={CisUI().hideUnordered}
                    className={CisUI().sematicUI.table}
                    filterValue={state.filterValue}
                    perPage={CisUI().perPage}
                    sortable
                    withLinks
                    withHeader
                    loader={CisUI().loader}
                    parseBool={{
                        yesWord: 'Yes',
                        noWord: 'No',
                    }}
                    parseImg={{
                        style: {
                            border: '1px solid #ddd',
                            borderRadius: '50px',
                            padding: '3px',
                            width: '30px',
                            height: '30px'
                        },
                    }}
                    emptyTable={CisUI().emptyTable}
                />

                <div className="row">
                    <div className="col-md-4" />
                    <div className="col-md-4">
                        <table className="table table-bordered" align="center" style={{width: '300px'}}>
                            <tr>
                                <th>Total</th>
                                <td align="right">{CisUI().getCurrencyFormated1(ttl.total)}</td>
                            </tr>
                            <tr>
                                <th>Local</th>
                                <td align="right">{CisUI().getCurrencyFormated1(ttl.totalLocal)}</td>
                            </tr>
                            <tr>
                                <th>District</th>
                                <td align="right">{CisUI().getCurrencyFormated1(ttl.totalDistrict)}</td>
                            </tr>
                            <tr>
                                <th>Region</th>
                                <td align="right">{CisUI().getCurrencyFormated1(ttl.totalRegion)}</td>
                            </tr>
                            <tr>
                                <th>Remit</th>
                                <td align="right">{CisUI().getCurrencyFormated1(ttl.totalRemit)}</td>
                            </tr>
                        </table>
                    </div>
                    <div className="col-md-4" />
                </div>

            </Card>
        </>
    );
};

export default CollectionHistory;